import axios from "axios";
import { APP_SETTINGS, PATH } from "../../../config";
import { toast } from "react-toastify";
console.log(
  "%c AXIOS INTERCEPTOR INSTANCE IS LOADED! LOGOUT SHOULD WORK.",
  "color: lime; font-size: 16px;"
 );
const getUserFromStorage = () => {
  try {
    const userStr = localStorage.getItem("user");
    return userStr ? JSON.parse(userStr) : null;
  } catch (e) {
    return null;
  }
};

const api = axios.create({
  baseURL: APP_SETTINGS.API_PATH.USER.login.substring(
    0,
    APP_SETTINGS.API_PATH.USER.login.lastIndexOf("/api") + 4
  ),
});

api.interceptors.request.use(
  (config) => {
    const user = getUserFromStorage();
    if (user && user.token) {
      config.headers["Authorization"] = `Bearer ${user.token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    console.log("api.interceptors.response");

    // if (status === 401 || status === 403) {
    //     if (!toast.isActive('session-expired-toast')) {
    //         localStorage.removeItem('user');
    //         toast.error("Session expired or unauthorized. Please log in again.", { toastId: 'session-expired-toast' });

    //         window.location.replace(PATH.LOGIN);
    //     }
    // }
    if (status === 401 || status === 403) {
      
      if (!toast.isActive("session-expired-toast")) {
        localStorage.removeItem("user");
        toast.error("...", { toastId: "session-expired-toast" });

        setTimeout(() => {
          window.location.replace(PATH.LOGIN);
        }, 50);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
